/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Defectnb1Inputs */



/**
* | output |
* | --- |
* | "Number of defects" |
*
* @param {Br_History_Key_Defectnb1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_defectnb1 = /** @type {((inputs?: Br_History_Key_Defectnb1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Defectnb1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of defects")
	return /** @type {LocalizedString} */ ("Nombre de défauts")
});
export { br_history_key_defectnb1 as "br_history_key_defectNb" }